import * as _ from 'lodash';

export class TabProcessor {
    _presets = {
        table: {
            content: '<sio-tab-table object.bind="object" tab.bind="tab"></sio-tab-table>',
            count: true
        },
        log: {
            content: '<sio-tab-log object.bind="object" tab.bind="tab"></sio-tab-log>',
        },
        overview: {
            content: '<sio-tab-overview object.bind="object" tab.bind="tab"></sio-tab-overview>',
        },
    };

    /**
     * Processes tab configuration:
     * -> loading config
     * -> preset resolving
     * -> count config evaluation
     */
    processTabs(config, object, showWithoutPermission) {
        let tabs = [];
        let permissionTabs = [];

        //Load tabs
        if (config) {
            tabs = config;
        } else if (object) {
            tabs = object?.['@tabs'] ?? [];
        } else {
            tabs = [];
        }

        //Process presets and filter tabs by permissions and conditions
        for (let i = 0; i < tabs.length; i++) {

            let tab = _.cloneDeep(tabs[i]);

            if (tab.preset) {
                let preset = this._presets[tab.preset.type];

                tab = Object.assign({}, preset, tab);

                if (tab.preset.properties) {
                    _.forIn(tab.preset.properties, (value, key) => {
                        tab.content = tab.content.replace('%' + key + '%', value);
                    });

                    if (tab.count) {
                        tab.count = {
                            modelId: tab.preset.properties.modelId
                        };
                    }
                }
            }

            if (tab.noPermission && !showWithoutPermission) {
                continue;
            }

            //Avoid leaking data for now
            if (tab?.preset?.type === 'table' && tab.noPermission) {
                continue;
            }

            permissionTabs.push(tab);
        }

        permissionTabs = _.sortBy(permissionTabs, ['weight']);

        return permissionTabs;
    }

}
